module.exports = __webpack_public_path__ + "img/first_de.d7c33c1d.jpg";